import { Skeleton, capitalize } from '@applift/factor'
import clsx from 'clsx'
import { useGridRootProps } from '../../hooks/utils/useGridRootProps'
import { ReactTableColumn } from '../../models/gridReactTable'
import styles from '../../style'

export interface GridSkeletonCellProps extends ReactTableColumn {
  height: number | 'auto'
  showRightBorder?: boolean
  colIndex: number
  contentWidth: number
}

export function GridSkeletonCell(props: GridSkeletonCellProps) {
  const {
    height,
    colIndex,
    showRightBorder,
    contentWidth,
    getSize,
    columnDef,
    id,
  } = props
  const rootProps = useGridRootProps()
  const SkeletonComponent = columnDef.meta?.skeleton ?? Skeleton

  const width = getSize()
  const align = columnDef.meta?.align
  const field = id

  const style = {
    minWidth: width,
    maxWidth: width,
    minHeight: height,
    maxHeight: height === 'auto' ? 'none' : height, // max-height doesn't support "auto"
  }

  return (
    <div
      style={style}
      className={clsx(
        styles.cell,
        rootProps.classes?.cell,
        rootProps.classes?.cellSkeleton,
        showRightBorder && [styles.withBorder, rootProps.classes?.withBorder],
        [
          // @ts-ignore
          styles[`cell--text${capitalize(align)}`],
          // @ts-ignore
          rootProps.classes?.[`cell--text${capitalize(align)}`],
        ]
      )}
      role="cell"
      data-field={field}
      data-colindex={colIndex}
    >
      <SkeletonComponent width={`${contentWidth}%`} animation={false} />
    </div>
  )
}
